module.exports = __webpack_public_path__ + "img/fairG.08fdf7c4.png";